import { apiErrors, apiMethodnames } from '../constants/common';
import { promiseTimer, pushIsRecognizedEvent } from '../helpers/log-batch';
import OrchCustomData from '../helpers/orch-custom-data';
import promiseTimeout from '../helpers/promise-timeout';

const { IS_RECOGNIZED } = apiMethodnames;
const promiseWrapper = function(instance, instanceName, data, method) {
  const obj = {};
  if (OrchCustomData.srcSdks.apiResponseCache.isRecognized[instanceName]) {
    return Promise.resolve({});
  }

  if (instance === null || instance === undefined) {
    obj[instanceName] = {
      error: apiErrors.NO_INSTANCE
    };
    OrchCustomData.setRecognized(obj);
    return Promise.resolve({});
  }

  return promiseTimer(instance, method, data, instanceName, pushIsRecognizedEvent)
    .then(res => {
      obj[instanceName] = res;
      OrchCustomData.setRecognized(obj);
      return Promise.resolve({ network: instanceName, res });
    })
    .catch(err => {
      obj[instanceName] = err;
      OrchCustomData.setRecognized(obj);
      return Promise.resolve({ err, network: instanceName });
    });
};

const isRecognized = (sdkInstance, network, data) => {
  const sdkPromise = promiseTimeout(
    promiseWrapper(sdkInstance, network, data, IS_RECOGNIZED),
    network
  );
  OrchCustomData.srcSdks.isRecognizedPromiseArr.push(sdkPromise);
  return sdkPromise;
};

export default isRecognized;
